// French translations
export const fr: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Chargement...',
  'common.error': 'Une erreur est survenue',
  'common.retry': 'Réessayer',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.continue': 'Continuer',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.skip': 'Passer',
  'common.done': 'Terminé',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.ok': 'OK',
  'common.check': 'Vérifier',
  'common.correct': 'Correct !',
  'common.incorrect': 'Incorrect',
  'common.tryAgain': 'Réessayer',
  'common.start': 'Commencer',
  'common.finish': 'Terminer',
  'common.submit': 'Soumettre',

  // ==================== NAVIGATION ====================
  'nav.home': 'Accueil',
  'nav.courses': 'Cours',
  'nav.vocabulary': 'Vocabulaire',
  'nav.profile': 'Profil',
  'nav.settings': 'Paramètres',
  'nav.logout': 'Déconnexion',
  'nav.leaderboard': 'Classement',
  'nav.aiTutor': 'Tuteur IA',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Bienvenue sur KoreanFlow !',
  'onboarding.selectLanguage': 'Sélectionnez votre langue',
  'onboarding.selectLanguageDesc': 'Choisissez la langue de l\'interface de l\'application',
  'onboarding.selectGoal': 'Quel est votre objectif d\'apprentissage ?',
  'onboarding.selectGoalDesc': 'Nous personnaliserons votre parcours d\'apprentissage',
  'onboarding.takeTest': 'Passer le test de niveau',
  'onboarding.takeTestDesc': 'Découvrez votre niveau de coréen en 5 minutes',
  'onboarding.skipTest': 'Passer pour l\'instant',
  'onboarding.skipTestDesc': 'Commencer depuis le début',
  'onboarding.letsGo': 'C\'est parti !',
  'onboarding.step': 'Étape',
  'onboarding.of': 'sur',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Test de niveau',
  'levelTest.subtitle': 'Découvrons votre niveau de coréen',
  'levelTest.duration': 'Environ 5 minutes',
  'levelTest.questions': 'questions',
  'levelTest.vocabulary': 'Vocabulaire',
  'levelTest.grammar': 'Grammaire',
  'levelTest.listening': 'Compréhension orale',
  'levelTest.speaking': 'Expression orale',
  'levelTest.analyzing': 'Analyse de vos résultats...',
  'levelTest.yourLevel': 'Votre niveau',
  'levelTest.congratulations': 'Félicitations !',
  'levelTest.resultDesc': 'Selon les résultats de votre test',
  'levelTest.startLearning': 'Commencer à apprendre',
  'levelTest.retakeTest': 'Repasser le test',
  'levelTest.sectionComplete': 'Section terminée',
  'levelTest.nextSection': 'Section suivante',
  'levelTest.listenAndAnswer': 'Écoutez et répondez',
  'levelTest.speakNow': 'Parlez maintenant',
  'levelTest.tapToListen': 'Appuyez pour écouter',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Débutant',
  'cefr.A2': 'Élémentaire',
  'cefr.B1': 'Intermédiaire',
  'cefr.B2': 'Intermédiaire avancé',
  'cefr.C1': 'Avancé',
  'cefr.C2': 'Maîtrise',
  'cefr.A1.desc': 'Salutations de base et expressions simples',
  'cefr.A2.desc': 'Conversations simples sur la vie quotidienne',
  'cefr.B1.desc': 'Peut gérer la plupart des situations de voyage',
  'cefr.B2.desc': 'Peut interagir couramment avec des locuteurs natifs',
  'cefr.C1.desc': 'Peut exprimer des idées couramment et spontanément',
  'cefr.C2.desc': 'Maîtrise quasi-native dans toutes les situations',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Ligue',
  'league.weeklyRanking': 'Classement hebdomadaire',
  'league.bronze': 'Bronze',
  'league.silver': 'Argent',
  'league.gold': 'Or',
  'league.platinum': 'Platine',
  'league.diamond': 'Diamant',
  'league.promotion': 'Zone de promotion',
  'league.demotion': 'Zone de relégation',
  'league.safe': 'Zone sûre',
  'league.weeklyXP': 'XP hebdomadaire',
  'league.rank': 'Rang',
  'league.daysLeft': 'jours restants',
  'league.promoted': 'Promu !',
  'league.demoted': 'Relégué',
  'league.stayed': 'Maintenu',
  'league.noData': 'Pas encore de données de classement',
  'league.earnXP': 'Gagnez des XP pour rejoindre la ligue !',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'Application n°1 pour apprendre le coréen',
  'landing.title': 'Apprenez le coréen',
  'landing.titleAccent': 'de façon amusante',
  'landing.subtitle': 'Maîtrisez le coréen avec des leçons courtes, du contenu K-Pop et K-Drama, et un retour sur la prononciation par IA. Rejoignez plus d\'1M d\'apprenants !',
  'landing.getStarted': 'Commencer gratuitement',
  'landing.learnMore': 'En savoir plus',
  'landing.login': 'Connexion',
  'landing.startFree': 'Commencer gratuitement',
  'landing.learners': 'Apprenants',
  'landing.lessons': 'Leçons',
  'landing.countries': 'Pays',

  // ==================== FEATURES ====================
  'features.title': 'Pourquoi KoreanFlow ?',
  'features.subtitle': 'Notre approche unique combine gamification, contenu authentique et technologie IA pour rendre l\'apprentissage du coréen amusant et efficace.',
  'features.streaks.title': 'Séries quotidiennes',
  'features.streaks.desc': 'Créez une habitude avec des objectifs quotidiens et des récompenses de série. Restez motivé avec XP et gemmes.',
  'features.folksong.title': 'Chansons traditionnelles',
  'features.folksong.desc': 'Apprenez le coréen à travers les chansons traditionnelles. Comprenez les paroles et la culture !',
  'features.culture.title': 'Culture coréenne',
  'features.culture.desc': 'Explorez les proverbes, l\'argot et les expressions essentielles. Maîtrisez les expressions authentiques.',
  'features.ai.title': 'Chatbot IA',
  'features.ai.desc': 'Pratiquez des conversations avec notre tuteur IA. Obtenez des retours et corrections instantanés.',
  'features.leaderboard.title': 'Classements',
  'features.leaderboard.desc': 'Affrontez des amis et apprenants du monde entier. Grimpez les classements hebdomadaires !',
  'features.srs.title': 'Vocabulaire SRS',
  'features.srs.desc': 'Le système de répétition intelligente garantit que vous retenez ce que vous apprenez. Pour toujours.',
  'features.pronunciation.title': 'Retour sur la prononciation',
  'features.pronunciation.desc': 'Analyse de prononciation par IA avec notation détaillée.',

  // ==================== CTA ====================
  'cta.title': 'Prêt à commencer votre voyage ?',
  'cta.subtitle': 'Rejoignez des millions d\'apprenants et commencez à parler coréen aujourd\'hui. C\'est gratuit !',
  'cta.button': 'Commencer à apprendre gratuitement',

  // ==================== AUTH ====================
  'auth.login': 'Connexion',
  'auth.register': 'Inscription',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'Entrez votre e-mail',
  'auth.password': 'Mot de passe',
  'auth.passwordPlaceholder': 'Créez un mot de passe',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.noAccount': 'Pas encore de compte ?',
  'auth.haveAccount': 'Déjà un compte ?',
  'auth.orContinueWith': 'ou continuer avec',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Créer un compte',
  'auth.createAccountTitle': 'Créez votre compte',
  'auth.createAccountSubtitle': 'Commencez votre voyage d\'apprentissage du coréen aujourd\'hui',
  'auth.username': 'Nom d\'utilisateur',
  'auth.usernamePlaceholder': 'Choisissez un nom d\'utilisateur',
  'auth.usernameHint': 'Lettres, chiffres et tirets bas uniquement',
  'auth.passwordHint': 'Au moins 8 caractères avec majuscule, minuscule et chiffre',
  'auth.nativeLanguage': 'Langue maternelle',
  'auth.nativeLanguageHint': 'Nous afficherons les explications dans cette langue',
  'auth.termsAgree': 'En vous inscrivant, vous acceptez nos',
  'auth.terms': 'Conditions',
  'auth.and': 'et',
  'auth.privacyPolicy': 'Politique de confidentialité',
  'auth.loginTitle': 'Bon retour',
  'auth.loginSubtitle': 'Connectez-vous pour continuer à apprendre',
  'auth.loginButton': 'Se connecter',
  'auth.registerButton': 'S\'inscrire',
  'auth.rememberMe': 'Se souvenir de moi',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Bon retour',
  'dashboard.todayGoal': 'Objectif du jour',
  'dashboard.streak': 'Série',
  'dashboard.days': 'jours',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Niveau',
  'dashboard.continueLearning': 'Continuer à apprendre',
  'dashboard.recommended': 'Recommandé pour vous',
  'dashboard.myCourses': 'Mes cours',
  'dashboard.seeAll': 'Voir tout',
  'dashboard.dailyGoalComplete': 'Objectif quotidien atteint !',
  'dashboard.keepGoing': 'Continuez !',
  'dashboard.yourLevel': 'Votre niveau',
  'dashboard.weeklyProgress': 'Progression hebdomadaire',

  // ==================== COURSES ====================
  'courses.title': 'Tous les cours',
  'courses.search': 'Rechercher des cours...',
  'courses.all': 'Tous',
  'courses.beginner': 'Débutant',
  'courses.elementary': 'Élémentaire',
  'courses.intermediate': 'Intermédiaire',
  'courses.advanced': 'Avancé',
  'courses.lessons': 'leçons',
  'courses.enrolled': 'inscrits',
  'courses.progress': 'Progression',
  'courses.completed': 'terminé',
  'courses.recommended': 'Recommandé',
  'courses.forYourLevel': 'Pour votre niveau',
  'courses.locked': 'Verrouillé',
  'courses.unlockWith': 'Débloquer avec Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Chargement de la leçon...',
  'lesson.notFound': 'Leçon introuvable',
  'lesson.quit': 'Êtes-vous sûr de vouloir quitter ? Votre progression sera perdue.',
  'lesson.complete': 'Leçon terminée !',
  'lesson.perfect': 'Parfait !',
  'lesson.amazing': 'Incroyable ! Tout juste !',
  'lesson.xpEarned': 'XP gagnés',
  'lesson.accuracy': 'Précision',
  'lesson.correct': 'Correct',
  'lesson.goBack': 'Retour',
  'lesson.skip': 'Passer',
  'lesson.unknownType': 'Type d\'exercice inconnu',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Appuyez pour révéler la réponse',
  'exercise.matchPairs': 'Associez les paires',
  'exercise.matched': 'associé',
  'exercise.arrangeWords': 'Arrangez les mots',
  'exercise.speak': 'Parler',
  'exercise.listening': 'Écoute... Parlez maintenant !',
  'exercise.processing': 'Traitement de votre voix...',
  'exercise.tapToSpeak': 'Appuyez pour parler',
  'exercise.cantSpeak': 'Vous ne pouvez pas parler maintenant ? Passer',
  'exercise.again': 'Encore',
  'exercise.gotIt': 'Compris !',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Pratique de prononciation',
  'pronunciation.subtitle': 'Améliorez votre prononciation coréenne avec le retour IA',
  'pronunciation.selectLevel': 'Sélectionnez votre niveau',
  'pronunciation.beginner': 'Débutant',
  'pronunciation.intermediate': 'Intermédiaire',
  'pronunciation.advanced': 'Avancé',
  'pronunciation.score': 'Votre score',
  'pronunciation.accuracy': 'Précision',
  'pronunciation.fluency': 'Fluidité',
  'pronunciation.intonation': 'Intonation',
  'pronunciation.feedback': 'Retour',
  'pronunciation.tryAgain': 'Réessayer',
  'pronunciation.next': 'Suivant',
  'pronunciation.listen': 'Écouter',
  'pronunciation.slow': 'Lent',
  'pronunciation.sessionComplete': 'Session terminée !',
  'pronunciation.bestScore': 'Meilleur score',
  'pronunciation.average': 'Moyenne',
  'pronunciation.attempts': 'Tentatives',
  'pronunciation.practiceAgain': 'Pratiquer à nouveau',
  'pronunciation.changeLevel': 'Changer de niveau',
  'pronunciation.tips': 'Conseils pour une meilleure prononciation',
  'pronunciation.tip1': 'Écoutez d\'abord l\'audio',
  'pronunciation.tip2': 'Parlez clairement et à un rythme régulier',
  'pronunciation.tip3': 'Utilisez la lecture lente pour les mots difficiles',
  'pronunciation.tip4': 'Pratiquez dans un environnement calme',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Vocabulaire',
  'vocab.totalWords': 'Mots totaux',
  'vocab.mastered': 'Maîtrisés',
  'vocab.dueToday': 'À revoir aujourd\'hui',
  'vocab.reviewSession': 'Session de révision',
  'vocab.wordsDue': 'mots à réviser',
  'vocab.startReview': 'Commencer la révision',
  'vocab.allCaughtUp': 'Tout est à jour !',
  'vocab.noWordsDue': 'Aucun mot à réviser',
  'vocab.sessionComplete': 'Session terminée !',
  'vocab.allWords': 'Tous les mots',

  // ==================== PROFILE ====================
  'profile.title': 'Profil',
  'profile.level': 'Niveau',
  'profile.xpToNext': 'XP pour le prochain niveau',
  'profile.totalXp': 'XP total',
  'profile.currentStreak': 'Série actuelle',
  'profile.lessonsDone': 'Leçons terminées',
  'profile.timeLearned': 'Temps d\'apprentissage',
  'profile.achievements': 'Succès',
  'profile.settings': 'Paramètres',
  'profile.dailyGoals': 'Objectifs quotidiens',
  'profile.allAchievements': 'Tous les succès',
  'profile.logOut': 'Déconnexion',
  'profile.koreanLevel': 'Niveau de coréen',

  // ==================== SETTINGS ====================
  'settings.title': 'Paramètres',
  'settings.language': 'Langue de l\'application',
  'settings.preferences': 'Préférences',
  'settings.sound': 'Effets sonores',
  'settings.soundEffects': 'Effets sonores',
  'settings.soundEffectsDesc': 'Jouer des sons lors des exercices',
  'settings.notifications': 'Notifications',
  'settings.notificationsDesc': 'Recevoir des rappels d\'apprentissage quotidiens',
  'settings.darkMode': 'Mode sombre',
  'settings.darkModeDesc': 'Thème sombre pour un visionnage plus confortable',
  'settings.dailyReminder': 'Rappel quotidien',
  'settings.account': 'Compte',
  'settings.editProfile': 'Modifier le profil',
  'settings.privacy': 'Confidentialité',
  'settings.help': 'Aide',
  'settings.about': 'À propos',
  'settings.retakeTest': 'Repasser le test de niveau',
  'settings.retakeTestDesc': 'Vérifiez votre niveau actuel de coréen',
  'settings.terms': 'Conditions d\'utilisation',

  // ==================== FOOTER ====================
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.contact': 'Contact',
  'footer.rights': 'Tous droits réservés.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Vocabulaire',
  'quickAction.reviewWords': 'Réviser les mots',
  'quickAction.allCourses': 'Tous les cours',
  'quickAction.browseLessons': 'Parcourir les leçons',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Cours introuvable',
  'courseDetail.lessons': 'leçons',
  'courseDetail.completed': 'terminé',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Accueil',
  'bottomNav.courses': 'Cours',
  'bottomNav.vocab': 'Vocab',
  'bottomNav.profile': 'Profil',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'Tuteur IA',
  'aiTutor.selectScenario': 'Sélectionnez un scénario',
  'aiTutor.freeTalk': 'Conversation libre',
  'aiTutor.cafe': 'Commander au café',
  'aiTutor.shopping': 'Shopping',
  'aiTutor.restaurant': 'Restaurant',
  'aiTutor.friends': 'Se faire des amis',
  'aiTutor.interview': 'Entretien d\'embauche',
  'aiTutor.typeMessage': 'Tapez un message...',
  'aiTutor.send': 'Envoyer',

  // ==================== ERRORS ====================
  'error.generic': 'Quelque chose s\'est mal passé',
  'error.network': 'Erreur réseau. Veuillez vérifier votre connexion.',
  'error.notFound': 'Page introuvable',
  'error.unauthorized': 'Veuillez vous connecter pour continuer',
  'error.microphoneAccess': 'Accès au microphone refusé',
  'error.speechNotSupported': 'Reconnaissance vocale non prise en charge. Essayez Chrome.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Nous utilisons des cookies',
  'cookie.description': 'Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic du site et personnaliser le contenu. Vous pouvez choisir d\'accepter ou de refuser les cookies non essentiels.',
  'cookie.learnMore': 'En savoir plus',
  'cookie.acceptAll': 'Tout accepter',
  'cookie.rejectAll': 'Tout refuser',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Apprendre',
  'nav.culture': 'Culture',
  'nav.chat': 'Discussion',
  'nav.ranking': 'Classement',
  'nav.family': 'Famille',
  'nav.premium': 'Premium',
  'home.greeting': 'Bonjour',
  'home.streak': 'jours d\'affilée',
  'home.dailyGoal': 'Objectif du jour',
  'home.myLanguages': 'Mes langues',
  'home.addLanguage': 'Ajouter une langue',
  'home.recommended': 'Recommandé',
  'home.continue': 'Continuer l\'apprentissage',
  'home.selectLanguage': 'Choisir une langue',
  'home.totalXp': 'XP total',
  'home.bestStreak': 'Meilleure série',
  'home.level': 'Niveau',
  'chat.aiTutor': 'Tuteur IA',
  'chat.aiTutorDesc': 'Pratiquez la conversation avec l\'IA',
  'onboarding.welcome.subtitle': 'Apprenez n\'importe quelle langue grâce aux conversations avec l\'IA',
  'onboarding.selectUILanguage': 'Choisissez votre langue',
  'onboarding.selectUILanguage.subtitle': 'Elle sera utilisée pour l\'interface de l\'application',
  'onboarding.selectLearningLanguage': 'Que souhaitez-vous apprendre ?',
  'onboarding.selectLearningLanguage.subtitle': 'Vous pouvez apprendre plusieurs langues',
  'onboarding.selectDailyGoal': 'Définissez votre objectif quotidien',
  'onboarding.selectDailyGoal.subtitle': 'Combien de temps pouvez-vous consacrer chaque jour ?',
  'onboarding.ready': 'Tout est prêt !',
  'onboarding.ready.subtitle': 'Commençons votre parcours linguistique',
  'onboarding.features.languages': '4 langues',
  'onboarding.features.aiTutor': 'Tuteur IA',
  'onboarding.features.dailyGoals': 'Objectifs quotidiens',
  'dailyGoal.5min': '5 minutes',
  'dailyGoal.10min': '10 minutes',
  'dailyGoal.15min': '15 minutes',
  'dailyGoal.20min': '20 minutes',
  'dailyGoal.casual': 'Rythme tranquille',
  'dailyGoal.regular': 'Pratique régulière',
  'dailyGoal.serious': 'Apprenant assidu',
  'dailyGoal.intense': 'Entraînement intensif',
  'learn.title': 'Apprendre',
  'learn.currentLevel': 'Niveau actuel',
  'learn.noCoursesYet': 'Bientôt disponible !',
  'learn.noCoursesDescription': 'Les cours pour cette langue sont en préparation.',
  'learn.lessonsCompleted': 'leçons terminées',
  'learn.startCourse': 'Commencer le cours',
  'learn.continueCourse': 'Continuer',
  'learn.courseCompleted': 'Terminé',
  'learn.locked': 'Verrouillé',
  'learn.unlockBy': 'Terminez le cours précédent pour déverrouiller',
  'course.progress': 'Progression',
  'course.lessons': 'Leçons',
  'course.lessonsCompleted': 'leçons terminées',
  'course.noLessons': 'Les leçons sont en préparation...',
  'lesson.tapToReveal': 'Appuyez pour voir le sens',
  'lesson.examples': 'Exemples',
  'lesson.questionsCorrect': 'correctes',
  'lesson.wordsLearned': 'Mots',
  'lesson.grammarPoints': 'Grammaire',
  'lesson.backToCourse': 'Retour au cours',
  'lesson.practiceAgain': 'Réviser à nouveau',
  'lesson.whatYouLearn': 'Ce que vous allez apprendre',
  'lesson.newWords': 'nouveaux mots',
  'lesson.exercises': 'exercices',
  'lesson.startLesson': 'Commencer la leçon',
  'lesson.reviewLesson': 'Réviser la leçon',
  'lesson.learnVocabulary': 'Apprendre le vocabulaire',
  'lesson.grammarPoint': 'Point de grammaire',
  'lesson.practice': 'S\'entraîner',
  'profile.guest': 'Invité',
  'profile.days': 'jours',
  'profile.longestStreak': 'Plus longue',
  'profile.lessonsCompleted': 'terminées',
  'profile.dailyGoal': 'Objectif du jour',
  'profile.learningLanguages': 'Langues en cours',
  'profile.noLanguages': 'Aucune langue sélectionnée',
  'profile.minutesPerDay': 'min/jour',
  'profile.learningHistory': 'Historique d\'apprentissage',
  'profile.viewProgress': 'Voir votre progression',
  'profile.appSettings': 'Paramètres de l\'app',
  'profile.languageNotifications': 'Langue, notifications',
  'profile.loginToSave': 'Connectez-vous pour sauvegarder votre progression',
  'settings.learning': 'Apprentissage',
  'settings.dailyGoal': 'Objectif du jour',
  'settings.minutesPerDay': 'minutes par jour',
  'settings.selectLanguage': 'Choisir la langue',
  'settings.selectDailyGoal': 'Définir l\'objectif quotidien',
  'settings.perDay': 'par jour',
  'settings.appInfo': 'À propos de l\'app',
  'settings.logout': 'Se déconnecter',
};

export default fr;
